import { render } from "./CareerPage.vue?vue&type=template&id=cca85954&scoped=true"
import script from "./CareerPage.vue?vue&type=script&lang=js"
export * from "./CareerPage.vue?vue&type=script&lang=js"

import "./CareerPage.vue?vue&type=style&index=0&id=cca85954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca85954"]])

export default __exports__